module.exports = __webpack_public_path__ + "img/sponser-3.e2939522.png";